import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { SpinnerSize } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-spinner",
    template: "",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsSpinnerComponent {
    static readonly displayName = "sps-spinner";
    static readonly props = {
        size: "SpinnerSize",
    };

    @Input() size: SpinnerSize = SpinnerSize.MEDIUM;

    @HostBinding("class.sps-spinner") readonly _spsSpinnerClass = true;

    @HostBinding("class.sps-spinner--small")
    get _isSmall() {
        return this.size === SpinnerSize.SMALL;
    }

    @HostBinding("class.sps-spinner--large")
    get _isLarge() {
        return this.size === SpinnerSize.LARGE;
    }
}
